import axios from "axios";
import moment from "moment";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { io } from "socket.io-client";
import Swal from "sweetalert2";
import { changeSelectedChat } from "../../../actions/chatActions";
import { getAllMessages, imageURL, soketURL, url } from "../../../api";
import { Image, PDF, SendDocument } from "../../../assets/images";
import searchIcon from "../../../assets/images/searchIcon.png";
import LoadingSpinner from "../../../Components/Spinner/Spinner";
import { useSearch } from "../../../hooks/useSearch";
import { handleJoinMeeting } from "../../../helpers/index";
import "./Messages.css";
import { Tooltip } from "antd";

const socket = io.connect(soketURL);
export default function MessagingPage() {
  const history = useHistory();

  const [file, setFile] = useState({});
  const [users, setUsers] = useState([]);

  const token = localStorage.getItem("token");

  const chatId = useSelector((state) => state.chat);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [showChat, setShowChat] = useState(false);

  function handleWindowSizeChange() {
    setScreenWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isMobile = screenWidth <= 565;

  const dispatch = useDispatch();
  // set heading and chats

  const getChatRoom = async () => {
    let res = await axios.get(`${url}/twilio/get-chat-room`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (res.status == "201") {
      setUsers(res?.data?.chat);
    }
  };

  // data states
  var { user } = useSelector((state) => state.auth);
  if (user?.token) {
    user = user?.user;
  }
  const senderId = user?.patient?._id;
  const [selectedChat, setSelectedChat] = useState();
  const [chat, setChat] = useState([]);
  const [hideUseChats, setHideUserChats] = useState(true);
  const [newText, setNewText] = useState();

  useEffect(() => {
    if (users.length > 0) {
      users.forEach((record, index) => {
        users[
          index
        ].fullName = `${record.patientId.firstName} ${record.patientId.lastName}`;
      });
    }
  }, [users]);
  const { filteredData, onInputChange } = useSearch(users, ["fullName"]);

  // helping states
  const [loading, setLoading] = useState(false);
  const sendMessage = () => {
    if (file)
      socket.emit(
        "upload",
        file,
        file?.name,
        file?.type,
        user?.patient?._id,
        selectedChat?._id,
        selectedChat?.doctorId?._id,
        (status, message) => {
          setFile();
          document.getElementById("input_file").value = "";
          if (!status) {
            Swal.fire(message, "", "error");
          }
        }
      );
    if (newText)
      socket.emit("chat", {
        message: newText,
        sender: senderId,
        receiver: selectedChat?.doctorId?._id || selectedChat?.doctorId,
        chatRoomId: selectedChat?._id,
      });
    setNewText("");
  };

  const seletedChatIcon = selectedChat?.chatRoomType;
  const seletedChatTitle = selectedChat?.conversationName;
  const messages = "Messages";
  useEffect(() => {
    socket.on("chat", (payload) => {
      if (chat) {
        setChat([...chat, payload]);
      }
    });
  }, [chat]);
  useEffect(() => {
    getChatRoom().then(() => setSelectedChat(chatId));
    return () => dispatch(changeSelectedChat(null));
  }, []);
  useEffect(() => {
    (async () => {
      try {
        if (chatId) {
          const data = await getAllMessages(chatId?._id || chatId);
          setChat(data?.data);
          scrollToBottom();
        }
      } catch (error) {
        Swal.fire(error?.response?.data?.message, "", "error");
      }
    })();
  }, [selectedChat, chatId]);

  useEffect(() => {
    socket.emit("join", {
      senderId,
      chatRoomId: selectedChat?._id,
    });
    setFile();
  }, [selectedChat]);

  const messagesEndRef = useRef(null);
  const scrollToBottom = () =>
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  // if(!isMobile){
  //   setShowChat(false)
  //   setHideUserChats(true)
  // }

  return (
    <>
      <div className="contentRow pt-2">
        <div className="secDiv p-0 message">
          {loading && <LoadingSpinner />}
          {loading || (
            <div className="mainFlex">
              {hideUseChats && (
                <div className="userSec  d-md-block py-3 md:ml-[-30px]">
                  <div className=" px-2  border-gray-300">
                    <div className="searchBar">
                      <input
                        onChange={onInputChange}
                        placeholder="Seacrh Inbox"
                        className="search"
                      ></input>
                      <div className="searchIconDiv">
                        <img
                          className="searchIcon w-100"
                          src={searchIcon}
                          alt="search"
                        ></img>
                      </div>
                    </div>
                  </div>

                  <div className="sectionScroll-chats h-[73vh] overflow-y-scroll ">
                    {!users && <LoadingSpinner />}
                    {users?.length > 0 &&
                      filteredData?.map((chat) => {
                        return (
                          <>
                            <div
                              className={`py-1 px-2 mb-[10px] mt-[5px] flex msg-box ml-[20px] bg-[#f0f8f8] h-[50px] 
                         ${
                           selectedChat?._id === chat?._id
                             ? "shadow-inner select-change"
                             : " "
                         }`}
                              onClick={() => {
                                setSelectedChat(chat);
                                dispatch(changeSelectedChat(chat?._id));
                                if (isMobile) {
                                  setShowChat(true);
                                  setHideUserChats(false);
                                }
                              }}
                              key={chat?._id}
                            >
                              <div className="image-div flex items-center">
                                {chat?.chatRoomType == "phone_call" ? (
                                  <img
                                    src="/img/call.png"
                                    alt="call"
                                    width="30px"
                                    height="30px"
                                  />
                                ) : chat?.chatRoomType == "video_call" ? (
                                  <img
                                    src="/img/video.png"
                                    width="30px"
                                    height="30px"
                                  />
                                ) : (
                                  <img
                                    src="/img/google-docs.png"
                                    width="30px"
                                    height="30px"
                                  />
                                )}
                              </div>
                              <div
                                className="flex flex-column"
                                style={{
                                  width: "100%",
                                  textAlign: "justify",
                                  overflow: "hidden",
                                }}
                              >
                                <div className="ml-[10px] flex flex-column mt-[15px]">
                                  <h5 className="text-[16px]  font-medium text-left  ">
                                    {chat?.conversationName}{" "}
                                  </h5>
                                  <h5 className="mt-[10px] mb-[10px] font-medium text-[#EC6C00]">
                                    {chat?.patientId?.firstName +
                                      " " +
                                      chat?.patientId?.lastName}
                                  </h5>
                                  <p
                                    className="text-[12px] truncate max-w-[150px]"
                                    style={{
                                      width: "100%",
                                      height: "32px",
                                      overflow: "hidden",
                                      textAlign: "justify",
                                    }}
                                  >
                                    {chat?.last_message?.message ||
                                      "Tap to chat"}
                                  </p>
                                </div>
                                <div className="text-[10px] ml-[10px] flex content-end justify-end">
                                  {(chat?.last_message?.createdAt &&
                                    moment(
                                      chat?.last_message?.createdAt
                                    ).calendar()) ??
                                    moment(chat?.createdAt).calendar()}
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                    {users?.length <= 0 && (
                      <p style={{ width: "100%", textAlign: "center" }}>
                        No users found
                      </p>
                    )}
                  </div>
                </div>
              )}
              <div
                className="w-full   pt-[1rem]  h-[80vh] forResponsiveChat "
                style={{ display: showChat && "block" }}
              >
                {isMobile && (
                  <button
                    className="backToUsers"
                    onClick={() => {
                      if (isMobile) {
                        setShowChat(false);
                        setHideUserChats(true);
                      }
                    }}
                  >
                    <ArrowBackIcon />
                  </button>
                )}
                <div className=" message-body-name col-lg-12 px-2 py-1 border-b flex border-gray-300">
                  <div className="w-[50%] start flex align-items-center">
                    <h5 className=" text-[16px] pt-1 font-bold leading-[24px] text-[#404041]  ">
                      {selectedChat ? seletedChatTitle : messages}
                    </h5>
                  </div>
                  <div className="w-[50%] end">
                    {seletedChatIcon == "phone_call" ? (
                      <Tooltip title={"Call"} placement="bottom">
                        <img
                          src="/img/call.png"
                          alt="call"
                          width="30px"
                          height="30px"
                          style={{ cursor: "pointer" }}
                        />
                      </Tooltip>
                    ) : seletedChatIcon == "video_call" ? (
                      <img
                        src="/img/video.png"
                        width="30px"
                        height="30px"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          handleJoinMeeting(
                            selectedChat?.conversationId,
                            selectedChat?.conversationId?.doctorId,
                            true,
                            history
                          )
                        }
                      />
                    ) : seletedChatIcon == "written_report_analysis" ? (
                      <img
                        src="/img/google-docs.png"
                        width="30px"
                        height="30px"
                        style={{ cursor: "pointer" }}
                      />
                    ) : null}
                  </div>
                </div>
                <div className="w-full px-2 flex items-end ">
                  {chat === null && <LoadingSpinner />}
                  <div className="w-full px-2 flex items-end">
                    <div className=" w-full h-[73vh] ">
                      <div className=" overflow-y-auto sectionScroll">
                        {typeof chat === "object" &&
                          chat?.map((msg) => {
                            if (msg.sender === senderId) {
                              if (msg?.message) {
                                return (
                                  <div className="flex justify-end w-full">
                                    <div className="w-[60%] mr-[10px] ">
                                      <div className="bg-[#fff] my-1 w-full rounded-[5px] border border-r  px-2 pb-[13px] pt-[16px] ">
                                        <h1 className="text-[12px] font-medium leading-[18px] text-[#404041] break-words max-w-[60vw] md:max-w-[450px]">
                                          {msg?.message}
                                        </h1>
                                      </div>
                                      <h5 className="text-right px-1 text-[10px] font-medium text-[#878787]  ">
                                        {(msg?.createdAt &&
                                          moment(msg.createdAt).calendar()) ??
                                          "??"}
                                      </h5>
                                    </div>
                                  </div>
                                );
                              }
                              if (msg?.file?.file)
                                return (
                                  <div className="flex justify-end mr-2">
                                    <div className="file">
                                      <div className="flex  items-end">
                                        <a
                                          href={`${imageURL}/${msg.file.file}`}
                                          download
                                          target={"_blank"}
                                        >
                                          {msg.file.fileType.split("/")[1] ===
                                          "pdf" ? (
                                            <PDF />
                                          ) : (
                                            <Image />
                                          )}
                                        </a>
                                        <a
                                          href={`${imageURL}/${msg.file.file}`}
                                          download
                                          target={"_blank"}
                                        >
                                          <text className="ml-2 text-blue-400 pointer text-[14px]">
                                            Download
                                          </text>
                                        </a>
                                      </div>
                                      <p className="text-[14px] font-bold mt-[20px]">
                                        {msg.file.fileName}
                                      </p>
                                    </div>
                                  </div>
                                );
                            } else if (msg?.sender !== senderId)
                              if (msg?.message) {
                                return (
                                  <>
                                    <div className="w-full h-auto p-2   items-end  ">
                                      <div className="my-1 w-[60%] rounded-[5px] border-[#FF6E00] bg-[#FF6E00] border-l px-2 pb-[13px] pt-[16px] ">
                                        <h1 className="text-[12px] font-medium leading-[18px] text-[#fff] break-words max-w-[60vw] md:max-w-[450px]">
                                          {msg.message}
                                        </h1>
                                      </div>
                                      <h5 className=" px-1 text-[10px] font-medium text-[#878787]  ">
                                        {(msg?.createdAt &&
                                          moment(msg.createdAt).calendar()) ??
                                          "??"}
                                      </h5>
                                    </div>
                                    <div />
                                  </>
                                );
                              }
                            if (msg?.file?.file)
                              return (
                                <div className="flex justify-start mr-2">
                                  <div className="file">
                                    <div className="flex  items-end">
                                      <a
                                        href={`${imageURL}/${msg.file.file}`}
                                        download
                                        target={"_blank"}
                                      >
                                        {msg.file.fileType.split("/")[1] ===
                                        "pdf" ? (
                                          <PDF />
                                        ) : (
                                          <Image />
                                        )}
                                      </a>
                                      <a
                                        href={`${imageURL}/${msg.file.file}`}
                                        download
                                        target={"_blank"}
                                      >
                                        <text className="ml-2 text-blue-400 pointer text-[14px]">
                                          Download
                                        </text>
                                      </a>
                                    </div>
                                    <p className="text-[14px] font-bold mt-[20px]">
                                      {msg.file.fileName}
                                    </p>
                                  </div>
                                </div>
                              );
                          })}
                        <div ref={messagesEndRef} />
                      </div>
                      {selectedChat && chat && (
                        <div className="flex mt-[auto] message-input-tile">
                          <div className=" border border-gray-300 rounded-md w-[90%]  h-[50px]   flex">
                            <div className="w-[100%]">
                              <textarea
                                placeholder="Type Text Here..."
                                value={newText}
                                onChange={(e) => {
                                  setNewText(e.target.value);
                                }}
                                type="text"
                                className="p-2 resize-none h-[100%] w-full outline-none border-0 bg-transparent"
                              />
                            </div>
                            {!file && (
                              <div>
                                <div className="flex ">
                                  <label className="mt-2" htmlFor="input_file">
                                    <img
                                      className="mr-4 pointer"
                                      height={20}
                                      width={20}
                                      src={SendDocument}
                                    />
                                  </label>
                                  <label
                                    className="mt-2 mr-2"
                                    htmlFor="input_file_image"
                                  >
                                    <Image
                                      className="pointer"
                                      height="20"
                                      width="20"
                                    />
                                  </label>
                                </div>
                                <input
                                  id="input_file"
                                  type="file"
                                  hidden
                                  accept="application/pdf"
                                  onChange={(e) => {
                                    if (e.target.files[0])
                                      setFile(e.target.files[0]);
                                  }}
                                  className="flex items-center pointer"
                                ></input>
                                <input
                                  id="input_file_image"
                                  type="file"
                                  accept="image/*"
                                  hidden
                                  onChange={(e) => {
                                    if (e.target.files[0])
                                      setFile(e.target.files[0]);
                                  }}
                                  className="flex items-center pointer"
                                ></input>
                              </div>
                            )}
                            {file && (
                              <div className="flex align-center mt-2 mr-2">
                                <text className="text-blue-400 whitespace-nowrap truncate max-w-[200px]">
                                  {file.name}
                                </text>
                                <text
                                  onClick={() => setFile(null)}
                                  className="ml-2 pointer text-red-600"
                                >
                                  X
                                </text>
                              </div>
                            )}
                          </div>
                          <div className="flex items-end ml-[5px]">
                            <button
                              className="rounded-[5px] btn-color w-[51px] h-[50px] text-[14px] font-bold text-gray-50"
                              onClick={sendMessage}
                            >
                              Send
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
